import type { ShopTrackingPreferencesPatchDto } from "../generated/schema";
import useInvalidateShopSuspense from "./use-invalidate-shop-suspense";
import useInvalidateShopTrackingPreferencesSuspense from "./use-invalidate-shop-tracking-preferences-suspense";
import { useApiMutation } from "./use-api-mutation";

interface UseUpdateShopTrackingPreferencesOptions {
	showSuccessNotification?: boolean;
}

export default function useUpdateShopTrackingPreferences(
	options: UseUpdateShopTrackingPreferencesOptions = {},
) {
	const { showSuccessNotification = true } = options;
	const invalidateShop = useInvalidateShopSuspense();
	const invalidateShopTrackingPreferencesSuspense =
		useInvalidateShopTrackingPreferencesSuspense();

	return useApiMutation("patch", "/shops/{shopId}/tracking/preferences", {
		notify: showSuccessNotification,
		onSuccess: (_data, variables) => {
			const vars = variables as { shopId: string; requestBody: ShopTrackingPreferencesPatchDto };
			invalidateShop(vars.shopId);
			invalidateShopTrackingPreferencesSuspense(vars.shopId);
		},
		mapVariables: ({
			shopId,
			requestBody,
		}: {
			shopId: string;
			requestBody: ShopTrackingPreferencesPatchDto;
		}) => ({
			params: { path: { shopId } },
			body: requestBody,
		}),
	});
}
